<template>
  <div class="disclaimer">
    <div class="card">
      <div v-if="cancel" class="right_top" @click="close">
        <i class="el-icon-close"></i>
      </div>
      <div>
        <span style="font-weight: 900; font-size: 24px"> 温馨提示 </span>
      </div>
      <div class="row" style="text-align: left; font-size: 18px">
        <span style="line-height: 30px">
          点击以下按钮，您将从优行关爱平台离开，进入由第三方创建与监控的网站。该第三方网站的内容不受优行关爱平台控制或影响，也不对其内容承担任何责任。建议您在进入该第三方网站时阅读其隐私条款及规程，以确保您的合法权益得到适当的保护。
        </span>
      </div>
      <div class="row">
        <div class="countdown">
          <span>{{ countdown }} 秒后跳转</span>
        </div>
        <span class="button" @click="clickButton">立即跳转</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DisclaimerPage",
  props: {
    // 点击按钮后的方法
    confirm: {
      type: Function,
      default: null,
    },
    // 点击叉叉后的方法
    cancel: {
      type: Function,
      default: () => {
      },
    },
  },
  data() {
    return {
      countdown: 3, // 倒计时
      timer: 0, // 定时器
    };
  },
  methods: {
    clickButton() {
      if (this.confirm) {
        this.confirm();
        // this.timer = null;
      } else {
        this.close();
      }
    },
    close() {
      clearInterval(this.timer);
      if (this.cancel) this.cancel();
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.timer);
        this.clickButton();
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<style scoped>
.disclaimer {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  text-align: center;
  background-color: #3735352e;
  overflow: hidden;
}

/* 卡片式UI */
.card {
  position: relative;
  width: 240px;
  padding: 35px;
  margin-top: 80px;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.row {
  margin-top: 20px;
}

.button {
  display: inline-block;
  text-align: center;
  color: #fff;
  background-color: #d72618;
  border-radius: 20px;
  padding: 10px 20px 10px 20px;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
  text-decoration: none;
}

.button:hover {
  background-color: #c11b0f;
}

.right_top {
  position: absolute;
  top: 18px;
  right: 18px;
  transform: scale(2, 2);
  color: #bfbfbf;
}

.countdown {
  color: #adadad;
  line-height: 24px;
}
</style>
